export default __webpack_public_path__ + "static/media/login-wave.8850d041.svg";